const locale = {
    placeholder: 'Wybierz godzinę',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/pl_PL.tsx